import styled from "styled-components";

export const SortByContent = styled.div`
  display: grid;
  grid-template-columns: max-content min-content;
  grid-column-gap: ${props => props.theme.spacersm};
  grid-row-gap: ${props => props.theme.spacersm};
  align-items: center;
`;
